
<template>
  <page class="page">
    <mobile-form></mobile-form>

    <div class="descr">
      <div class="row">
        <h3>Take your share</h3>
        <img src="img/home/img1.png" />
        <div>Big Tech firms are secretly collecting hundreds of data points about you and selling them to advertisers.</div>
        <div>FairView lets you take back the control and charge advertisers for the right to display ads to you.</div>
        <ul>
          <li>An average internet user could be earning hundreds of pounds a year simply by installing our extension.</li>
          <li>View ads from the extension and advertisers pay you for it.</li>
        </ul>
      </div>

      <div class="join-us">
        <join-us-button />
      </div>

      <div class="row">
        <h3>Did you consent?</h3>
        <img src="img/home/img2.png" />
        <div>Big Tech firms are selling your information to advertisers and making huge profits. Yet advertisers might have products you would be happy to buy.</div>
        <ul>
          <li>You can bypass Big Tech with FairView.</li>
          <li>You specify what information about yourself that advertisers are allowed to use.</li>
          <li>Advertisers pay you money for the right to target ads to you.</li>
        </ul>
      </div>

      <div class="join-us">
        <join-us-button />
      </div>

      <div class="row">
        <h3>How it works</h3>
        <img src="img/home/img3.png" />
        <div>Big Tech firms make their profits by spying on you and selling your data to advertisers. This helps to show you relevant ads but ignores your privacy and keeps you hooked on social media platforms.</div>
        <div>Advertising money flows through complex channels, via hundreds of companies who take a share of the $300 billion a year industry.</div>
        <ul>
          <li>FairView was created to give users a share of the advertising money.</li>
          <li>You will be paid directly for your personal info and your attention.</li>
          <li>You see ads of interest to you and make money doing so.</li>
        </ul>
      </div>

      <div class="join-us">
        <join-us-button />
      </div>
    </div>
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import MobileForm from '@/views/ab/MobileForm.vue';
import JoinUsButton from '@/components/common/JoinUsButton.vue';

export default {
  components: {
    Page,
    MobileForm,
    JoinUsButton,
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200;600&family=Roboto:wght@100&display=swap');
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';

.page {
  margin-top: 0;
}

.join-us {
  text-align: center;
  justify-content: center;
  display: flex;
  padding: 10px;
  background-color: $blue;
}

.descr {
  * {
    font-family: 'Roboto', sans-serif;
  }

  h3 {
    font-family: 'Nunito', sans-serif;
  }

  img {
    height: 155px;
    width: 214px;
  }

  .row div {
    margin: 14px 0;
  }

  li {
    margin: 12px 0;
    margin-left: 32px;
    font-weight: bold;
    text-align: left;
    font-size: 11pt;
  }

  li::before {
    content: '';
    position: absolute;
    height: 18px;
    width: 18px;
    background: url('/img/icons/check.svg') no-repeat;
    margin-left: -28px;
  }

  div,
  h3 {
    text-align: center;
  }

  h3 {
    margin: 14px 0;
    font-size: 16pt;
  }
}
</style>

<style lang="scss">
.join-us {
  button {
    min-width: 85vw !important;
  }
}
</style>